import { getReviews } from "@/apis/getReviews"
import { usePdp } from "@jog/react-components"
import { ReviewsMinimal } from "@jog/types"
import { useEffect, useState } from "react"

export const useProductReviews = () => {
    const { detail } = usePdp()

    const [reviews, setReviews] = useState<ReviewsMinimal>()
    const [reviewLoading, setReviewLoading] = useState(true)
    useEffect(() => {
        setReviewLoading(true)
        getReviews(detail.slug)
            .then((res) => setReviews(res))
            .finally(() => setReviewLoading(false))
    }, [detail.slug])
    return { reviews, reviewLoading }
}
